import { ReactElement, useMemo, useCallback, useRef } from 'react';

import { FormHandles } from '@unform/core';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

import { DatePicker, Select } from '~/components';
import ContainerDate from '~/components/ContainerDate';
import { BillingTimeEnum } from '~/enum/billing.enum';

import * as S from './styles';

interface IBillingTimeOptions {
  label: string;
  value: BillingTimeEnum;
}

const BillingTimeOptions: IBillingTimeOptions[] = [
  {
    label: 'Últimos 15 dias',
    value: BillingTimeEnum.LAST_15_DAYS,
  },
  {
    label: 'Últimos 30 dias',
    value: BillingTimeEnum.LAST_MONTH,
  },
  {
    label: 'Último trimestre',
    value: BillingTimeEnum.LAST_QUARTER,
  },
  {
    label: 'Último semestre',
    value: BillingTimeEnum.LAST_SEMESTER,
  },
  {
    label: 'Último ano',
    value: BillingTimeEnum.LAST_YEAR,
  },
];

export const BillingMenuOptions = [
  { label: 'Plano comercial', value: 'comercial-plan' },
  { label: 'Forma de pagamento', value: 'payment-form' },
  { label: 'Status Finaceiro', value: 'status' },
  { label: 'Histórico Finaceiro', value: 'finance' },
];

const normalizeDate = (date: string) => {
  const [d, m, y] = date.split('/');

  return `${y}-${m}-${d}`;
};

export const handleGetDataInfo = (data: any) => {
  // eslint-disable-next-line prefer-const
  const query = new URLSearchParams();
  console.log({ data });
  if (data?.initial_date) {
    query.append('initialDate', normalizeDate(data?.initial_date));
  } else {
    const date = moment(new Date()).format('YYYY-MM-DD');
    query.append('initialDate', date);
  }

  if (data?.final_date) {
    query.append('lastDate', normalizeDate(data?.final_date));
  }

  if (data?.period) {
    query.append('period', data?.period);
  }

  return query.toString();
};

function Billing(): ReactElement {
  const formRef = useRef<FormHandles>(null);

  const router = useHistory();

  const handleGoBillingOption = useCallback(
    (billingOption: string) => {
      const data: any = formRef.current?.getData();

      router.push(`/billing/${billingOption}?${handleGetDataInfo(data)}`);
    },
    [router, handleGetDataInfo],
  );

  const BillingMenuMemo = useMemo(() => {
    return BillingMenuOptions.map(({ label, value }) => (
      <S.BillingMenuItem key={label}>
        <S.BillingMenuLink onClick={() => handleGoBillingOption(value)}>
          {label} <span>{'>'}</span>
        </S.BillingMenuLink>
      </S.BillingMenuItem>
    ));
  }, [handleGoBillingOption]);

  const handleSelectBillingOption = () => {
    return (
      <S.BillingOptionMenu
        id="edit-package"
        ref={formRef}
        onSubmit={() => {
          console.log('hey');
        }}
      >
        <ContainerDate label="Data início">
          <DatePicker name="initial_date" fieldLabel="" />
        </ContainerDate>

        <ContainerDate label="Data final">
          <DatePicker name="final_date" fieldLabel="" />
        </ContainerDate>

        {/* <ContainerDate label="Selecionar período">
          <Select
            name="period"
            options={BillingTimeOptions}
            containerStyle={{
              borderRadius: 0,
              backgroundColor: 'transparent',
              border: 'none',
              fontWeight: 'bold',
            }}
            initialValue={BillingTimeOptions[0]}
          />
        </ContainerDate> */}
      </S.BillingOptionMenu>
    );
  };

  return (
    <S.Container>
      {handleSelectBillingOption()}
      <S.BillingMenu>{BillingMenuMemo}</S.BillingMenu>
    </S.Container>
  );
}

export default Billing;
